<!-- 学生管理 -->
<template>
	<div class="fuzzy-matching-box">
		<!-- 学生管理 -->
		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="姓名:">
						<el-input v-model="Dform.studentName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="学号:">
						<el-input v-model="Dform.studentNo" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="5">
          <el-form-item label="RFID:">
            <el-input v-model="Dform.rfid" placeholder=''></el-input>
          </el-form-item>
        </el-col> -->

				<el-col :span="5">
					<el-form-item label="imei:">
						<el-input v-model="Dform.imei" placeholder=''></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="学校:">
						<!-- <el-input v-model="Dform.schoolName" placeholder=''></el-input> -->
						<el-select v-model="schoolListTopId" placeholder="请选择学校" @change="schoolClickTop"
							@click="schoolPost(true)">
							<el-option :label="item.name" :value="item.id" v-for="item in schoolListTop"
								:key="item.name"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="school_loading"><text>加载中...</text></div> -->
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="年级:">
						<!-- <el-input v-model="Dform.gradeName" placeholder=''></el-input> -->
						<el-select v-model="gradeDataListTopId" placeholder="请选择年级" @change="classClickTop"
							@click="gradePost()">
							<el-option :label="item.name" :value="item.id" v-for="item in gradeDataListTop"
								:key="item.name"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="grade_loading"><text>加载中...</text></div> -->
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="班级:">
						<!-- <el-input v-model="Dform.className" placeholder=''></el-input> -->
						<el-select v-model="classListTopId" placeholder="请选择班级" @click="classPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in classListTop"
								:key="item.name"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="class_loading"><text>加载中...</text></div> -->
					</el-form-item>
				</el-col>
				<el-col :span="5">
				</el-col>
				<el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
			</el-row>
		</div>
		<div class="fuzzy-matching-content">
			<el-button type="text" class="query-button" @click="AddClick">新增学生</el-button>	
			<!-- <el-button type="text" @click="daoRuClick">导入数据</el-button> -->
			<el-button type="text" class="query-button" @click="leadingFamily">导入NFC数据</el-button>
			<el-button type="text" class="query-button" @click="filtrateclick">导出筛选数据</el-button>
			<!-- <el-button type="text" class="query-button" @click="deriveFamily">导出数据</el-button> -->
			<el-button type="text" class="query-button" @click="daoRuClick">导入学生数据</el-button>
			<el-button type="text" class="query-button" @click="xiazaiNFCclick">下载NFC模版</el-button>
			<el-button type="text" class="query-button" @click="xiazaiclick">下载学生数据模板</el-button>
		</div>
		<div class="upload-box" v-if="titleValue == '导入数据' || titleValue == '导入NFC数据'">
			<el-form-item label="所属学校：">
				<!-- <el-select v-model="theuserValue" filterable placeholder="请选择数据来源"> -->
				<!-- <el-option label="研发中心" value="ff245e1e-8347-4bd4-a714-88d6f0641c96"></el-option> -->
				<!-- <el-option :label="item.name" :value="item.value" v-for="item in schoolList" :key="item.name"></el-option> -->
				<el-select v-model="Dform.region" filterable placeholder="请选择学校" @change="schoolClick">
					<el-option :label="item.name" :value="item.id" v-for="item in schoolList"
						:key="item.value"></el-option>
				</el-select>
				<!-- </el-select> -->
			</el-form-item>
			<div class="upload-lef">
				<!-- <div @click="clickUpload">上传附件</div> -->
				<span class="upload-title">请选择要导入的数据文件：</span>
				<input class="upload" style="cursor: pointer;" id="inputFile" type="file" @change="getFile($event)" />
				<el-button type="primary" @click="uploadClick">上传</el-button>
				<div>每次导入最多500条数据</div>
			</div>
		</div>
		<div class="upload-box" v-if="titleValue == '导出数据' && daochuValue">
			<el-form-item label="学校" prop="region">
				<el-select v-model="Dform.region" filterable placeholder="请选择学校" @change="schoolClick">
					<el-option :label="item.name" :value="item.id" v-for="item in schoolList"
						:key="item.value"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="年级" prop="classes">
				<el-select v-model="Dform.classes" filterable placeholder="请选择年级" @change="classClick">
					<el-option :label="item.name" :value="item.id" v-for="item in gradeDataList"
						:key="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="班级" prop="classes2">
				<el-select v-model="Dform.classes2" filterable placeholder="请选择班级">
					<el-option :label="item.name" :value="item.id" v-for="item in classList"
						:key="item.value"></el-option>
				</el-select>
				<el-button type="primary" @click="daochu">导出</el-button>
			</el-form-item>
			<!-- </el-row> -->
		</div>
		<div class="fuzzy-matching-bottom">
			<el-row class="list">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style="{ background: '#EDF6FF', color: '#000', }" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column prop="studentName" label="姓名" min-width="50">
					</el-table-column>
					<el-table-column label="姓别" min-width="50">
						<template #default="scope">
							<span v-if="scope.row.sex == 0">{{ '女' }}</span>
							<span v-if="scope.row.sex == 1">{{ '男' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="studentNo" label='学号'>
					</el-table-column>
					<el-table-column prop="schoolName" label="学校">
					</el-table-column>
					<el-table-column prop="gradeName" label="年级" width=" 180">
					</el-table-column>
					<el-table-column prop="className" label="班级" width="150">
					</el-table-column>
					<el-table-column label="类型" width="150">
						<template #default="scope">
							<span v-if="scope.row.liveSchool == 0">走读</span>
							<span v-if="scope.row.liveSchool == 1">住校</span>
						</template>
					</el-table-column>
					<el-table-column prop="imei" label="imei" width="200">
					</el-table-column>
					<el-table-column prop="mobileOne" label="家长电话1" show-overflow-tooltip>
					</el-table-column>
					<!-- <el-table-column prop="mobileTwo" label="家长电话2" width="130">
					</el-table-column>
					<el-table-column prop="mobileThree" label="家长电话3" width="130">
					</el-table-column> -->

					<!-- <el-table-column
            prop="country"
            label="国籍"
            >
          </el-table-column> -->
					<el-table-column label="绑定关系">
						<template #default="scope">
							<el-button type="primary" class="textButton" size="small" @click="addPeople(scope.row)"
								v-if="scope.row.imei != null">
								<el-icon :size="20">
									<UserFilled />
								</el-icon>1人绑定</el-button>
							<el-button type="info" class="textButton" size="small" @click="addPeople(scope.row)" v-else>
								<el-icon :size="20">
									<UserFilled />
								</el-icon>0人绑定</el-button>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="150">
						<template #default="scope">
							<el-button type="text" class="textButton" size="small" @click="reviseClick(scope.row)"
								style="padding: 5px;">修改</el-button>
															<el-button type="text" class="shanchuBtn red_bottom" size="small"
								@click="deleteClick(scope.row)" style="padding: 5px;">删除</el-button>
							<el-button type="text" class="textButton green_bottom" size="small"
								@click="BindingClick(scope.row)" v-if="scope.row.imei == '' || scope.row.imei == null"
								style="padding: 5px;">绑定终端</el-button>
							<el-button type="text" class="textButton red_bottom" size="small"
								@click="removeClick(scope.row)" v-else style="padding: 5px;">解除终端</el-button>

						</template>
					</el-table-column>

				</el-table>

				<div class="block">
					<div class="total"> 共<span class="texttiao">{{total}}</span>条记录，当前显示<span
							class="texttiao">{{ twigMin }}</span>到<span class="texttiao">{{ twigMax }}</span>条</div>

					<el-pagination :small="small" :disabled="disabled" :background="background"
						layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" />
				</div>
			</el-row>

		</div>
		<Add v-if="addShow" @addClick="addClick" :titleValue="titleValue" :detailsObj="detailsObj" :schoolData="schoolList" :defaultSchoolId="schoolListTopId"></Add>
		<DeviceAdd v-if="DeviceAddShow" @BindingShow="BindingShow" :Deviceidobj="Deviceidobj"></DeviceAdd>
		<People v-if="ShowPeople" @closeClick="closeClick" :PeopleObj="PeopleObj"></People>
	</div>
</template>
<script>
	import {
		schoolOrUserManagementList,
		studentjiechuRfid
	} from '@/assets/api/schoollog';
	import {
		importStudentInfo,
		importNfc,
		exportStudentInfo,
		studentDaoChuInfo,
		findStudentInfo,
		schoolOrUserinfoDelete,
		schoolList,
		gradeList,
		findClassList
	} from '@/assets/api/renyuan';
	import Add from './group/add.vue'
	import DeviceAdd from './group/deviceAdd.vue'
	import People from './group/People.vue'
	import {
		ElMessage,
		ElLoading
	} from 'element-plus'
	import {
		UserFilled
	} from "@element-plus/icons-vue"; // 图标

	export default {
		components: {
			Add,
			DeviceAdd,
			People,
			UserFilled
		},
		data() {
			return {
				daochuValue: false,
				loading: true,
				ShowPeople: false,
				Dform: {
					className: "",
					gradeName: "",
					schoolName: "",
					rfid: "",
					studentName: "",
					studentNo: "",
					imei: '',
					region: '',
					classes: '',
					classes2: '',
				},
				tableData: [

				],
				total: "",
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				theuserValue: 'ff245e1e-8347-4bd4-a714-88d6f0641c96',
				theuserList: [],
				tempFile: "", //文件
				titleValue: '',
				DeviceAddShow: false,
				addShow: false,
				detailsObj: {},
				Deviceidobj: {},
				schoolList: [],
				gradeDataList: [],
				classList: [],
				schoolListTopId: '',
				gradeDataListTopId: '',
				classListTopId: '',
				schoolListTop: [],
				gradeDataListTop: [],
				classListTop: [],
				twigMax: 0,
				twigMin: 0,
				school_loading: false,
				grade_loading: false,
				class_loading: false
			};
		},
		created() {
			this.schoolOrUserManagementListSearch()
		},
		mounted() {
			this.schoolPost(false)
		},
		methods: {
			//查看人员绑定关系
			addPeople(item) {
				console.log(item.imei, '查看');
				this.PeopleObj = item
				this.ShowPeople = true

			},
			closeClick() {
				this.ShowPeople = false

			},
			xiazaiNFCclick() {
				window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/NFC.xls'

			},
			xiazaiclick() {
				window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/student.xls'

			},
			// 导出批量筛选学生
			filtrateclick() {
				const params = {
					classId: this.classListTopId, // 班级
					rfidDecimal: this.Dform.rfid,
					gradeId: this.gradeDataListTopId, // 年级
					schoolId: this.schoolListTopId, // 学校
					studentName: this.Dform.studentName,
					studentNo: this.Dform.studentNo,
					page: this.pageInfo.page,
					pageSize: '9999',
					imei: this.Dform.imei,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				studentDaoChuInfo(params).then((res) => {
					this.handleExport(res.data, '学生筛选导出.xls')
				}).catch((err) => {
					// ElMessage.error("导出数据报表失败")
					ElMessage.error(err.response.data.msg)

				})
			},

			classPost() {
				let params = {
					page: '1',
					pageSize: '999',
				}
				this.class_loading = true;
				findClassList(params, this.gradeDataListTopId).then((res) => {
					this.classListTop = res.data.data;
					this.class_loading = false;
				}).catch((err) => {
					console.log(err);
					this.class_loading = false;
				})
			},

			gradePost() {
				let params = {
					page: '1',
					pageSize: '999',
				}
				this.grade_loading = true;
				gradeList(params, this.schoolListTopId).then((res) => {
					console.log(res, '年级列表');
					this.grade_loading = false;
					this.gradeDataListTop = res.data.data;
				}).catch((err) => {
					this.grade_loading = false;
					console.log(err);
				})
			},

			schoolPost(schooName) {
				if (this.schoolList.length > 0) {
					return;
				}

				let params = JSON.parse(localStorage.getItem('user')).id;
				if (schooName) {
					this.school_loading = true
				}
				schoolList(params).then((res) => {
					console.log(res, '学校列表');
					this.schoolList = res.data.data
					this.schoolListTop = res.data.data
					this.school_loading = false;
				}).catch((err) => {
					console.log(err);
					this.school_loading = false;
				})
			},

			schoolClickTop() {
				this.gradeDataListTopId = ''
				this.classListTopId = ''
				// this.Dform.classes = ''
				// this.Dform.classes2 = ''
				this.gradeDataListTop = []
				this.classListTop = []
			},

			classClickTop() {
				this.classListTopId = ''
				// this.Dform.classes2 = ''
				this.classListTop = []
			},
			schoolClick() {
				this.Dform.classes = ''
				this.Dform.classes2 = ''
				this.gradeDataList = []
				this.classList = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				gradeList(params, this.Dform.region).then((res) => {
					console.log(res, '年级列表');
					this.gradeDataList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
			classClick() {
				this.Dform.classes2 = ''
				this.classList = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				findClassList(params, this.Dform.classes).then((res) => {
					console.log(res, '班级列表');
					this.classList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
			//解除rfid
			removeClick(item) {
				this.$confirm('请确定要解绑imei吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.jiebangClick(item)

				}).catch((err) => {

				});


			},
			jiebangClick(item) {

				studentjiechuRfid(item.studentId).then((res) => {
					console.log(res);
					this.schoolOrUserManagementListSearch()
					this.$message({
						type: 'success',
						message: '解除成功!'
					});

				}).catch((err) => {
					// console.log(err);
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},

			// Add父传子控制按钮
			addClick() {
				this.addShow = false
				this.schoolOrUserManagementListSearch()
				console.log('修改成功');
			},
			// 新增按钮
			AddClick() {
				console.log('新增学生');
				this.titleValue = '新增学生'
				this.addShow = true
			},
			// Device父传子控制按钮
			BindingShow() {
				this.DeviceAddShow = false
				this.schoolOrUserManagementListSearch()
			},
			// 绑定终端
			BindingClick(imei) {
				console.log(imei, '绑定终端');
				this.Deviceidobj = imei
				console.log(this.Deviceidobj, '有数据');
				this.DeviceAddShow = true
			},
			//删除
			deleteClick(item) {
				this.$confirm('确定删除该学生吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deleteStatus(item)

				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				});
			},
			//删除接口
			deleteStatus(item) {
				const params = {
					studentId: item.studentId
				}
				schoolOrUserinfoDelete(params).then((res) => {
					// console.log(res,222);
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					this.schoolOrUserManagementListSearch()

				}).catch((err) => {
					// ElMessage.error('删除失败')
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},

			reviseClick(item) {
				this.titleValue = '修改学生信息'
				console.log(item, '888888');
				let params = {
					studentId: item.studentId
				}
				findStudentInfo(params).then((res) => {
					console.log(res);
					this.addShow = true
					this.detailsObj = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},
			daoRuClick() {
				console.log('导入数据');
				this.titleValue = '导入数据'
			},
			leadingFamily() {
				console.log('导入NFC数据');
				this.titleValue = '导入NFC数据'
			},
			deriveFamily() {
				this.titleValue = '导出数据'
				this.daochuValue = true
			},
			daochu() {
				// this.handleExport()
				if (this.Dform.region == '') return this.$message({
					showClose: true,
					message: '请先选择学校'
				});
				// if ( this.Dform.classes == '') return this.$message({showClose: true,message: '请选择年级'});
				// if ( this.Dform.classes2 == '') return this.$message({showClose: true,message: '请选择班级'});
				// let params = {
				//   classId: this.Dform.classes2 || null,
				//   gradeld: this.Dform.classes || null,
				//   schoolld: this.Dform.region,
				// }
				exportStudentInfo(this.Dform.region, this.Dform.classes || '', this.Dform.classes2 || '').then((res) => {
					console.log(res.data, '导出');
					this.handleExport(res.data, '学生信息.xls')
					this.daochuValue = false

				}).catch((err) => {
					console.log(err, 789799);
					this.$message({
						showClose: true,
						message: '数据为空，不可导出',
						type: 'error'
					});
				})
			},
			handleExport(data, name) {
				// 动态创建iframe下载文件
				let fileName = name;
				if (!data) {
					return;
				}
				let blob = new Blob([data], {
					type: "application/octet-stream"
				});
				console.log(blob);
				if ("download" in document.createElement("a")) {
					// 不是IE浏览器
					let url = window.URL.createObjectURL(blob);
					let link = document.createElement("a");
					link.style.display = "none";
					link.href = url;
					link.setAttribute("download", fileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link); // 下载完成移除元素
					window.URL.revokeObjectURL(url); // 释放掉blob对象
				} else {
					// IE 10+
					window.navigator.msSaveBlob(blob, fileName);
				}
			},
			getFile(event) {
				this.tempFile = event.target.files[0];
			},
			uploadClick() {
				let index = this.tempFile.name.lastIndexOf(".");
				let fileName = this.tempFile.name.substr(index + 1);
				var filetypes = [
					"jpg",
					"png",
					"gif",
					"jpeg",
					"doc",
					"ppt",
					"xls",
					"pdf",
					"docx",
					"xlsx",
				];
				if (filetypes.includes(fileName)) {
					if (this.tempFile) {
						let fileSize = this.tempFile.size / (1024 * 1024 * 60);
						if (this.tempFile.name) {
							let formData = new FormData();
							console.log(formData, 8888888);
							formData.append("file", this.tempFile);
							// 导入数据删除
							if (this.titleValue == '导入数据') {
								importStudentInfo(formData, this.Dform.region, JSON.parse(localStorage.getItem('user'))
									.id, ).then((res) => {
									// console.log(res.data);
									ElMessage({
										message: '学生信息上传成功',
										type: 'success',
									})
									this.handleExport(res.data, '学生信息上传成功.xls')

								}).catch((err) => {
									// console.log();
									ElMessage.error("上传失败")
								})
							} else if (this.titleValue == '导入NFC数据') {
								importNfc(formData, this.Dform.region).then((res) => {
									console.log(res);
									ElMessage({
										message: 'NFC数据上传成功',
										type: 'success',
									})
								}).catch((err) => {
									// console.log();
									ElMessage.error("上传失败")
								})
							}
						}
					}
				} else {
					ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
				}

			},

			schoolOrUserManagementListSearch() {
				const params = {
					// className: this.Dform.className,
					classId: this.classListTopId, // 班级
					rfidDecimal: this.Dform.rfid,
					// gradeName: this.Dform.gradeName,
					gradeId: this.gradeDataListTopId, // 年级
					// schoolName: this.Dform.schoolName,
					schoolId: this.schoolListTopId, // 学校
					studentName: this.Dform.studentName,
					studentNo: this.Dform.studentNo,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					imei: this.Dform.imei,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				schoolOrUserManagementList(params).then((res) => {
					// console.log( res.data.data.list,'学生管理成功');
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.loading = false
					let str = 0
					if (res.data.data.list.length < 10) {
						str = 10 - res.data.data.list.length
					}
					console.log(this.pageInfo.pageSize * this.pageInfo.page - 9, ']]]]]', this.pageInfo.pageSize *
						this.pageInfo.page - str);
					this.twigMin = this.pageInfo.pageSize * this.pageInfo.page - 9
					this.twigMax = this.pageInfo.pageSize * this.pageInfo.page - str

				}).catch((err) => {
					console.log(err, '学生管理失败');

				})
			},
			entrylogClick() {
				this.schoolOrUserManagementListSearch()
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.schoolOrUserManagementListSearch()
			},
			handleExport(data, name) {
				// 动态创建iframe下载文件
				let fileName = name;
				if (!data) {
					return;
				}
				let blob = new Blob([data], {
					type: "application/octet-stream"
				});
				console.log(blob);
				if ("download" in document.createElement("a")) {
					// 不是IE浏览器
					let url = window.URL.createObjectURL(blob);
					let link = document.createElement("a");
					link.style.display = "none";
					link.href = url;
					link.setAttribute("download", fileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link); // 下载完成移除元素
					window.URL.revokeObjectURL(url); // 释放掉blob对象
				} else {
					// IE 10+
					window.navigator.msSaveBlob(blob, fileName);
				}
			},

			openElLoading(text) {
				this.elLoading = ElLoading.service({
					lock: true,
					text: `${text}...`,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},

			closeElLoading() {
				if (this.elLoading) {
					this.elLoading.close();
					this.elLoading = null;
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.loading_view {
		position: absolute;
		padding: 5px;
		background-color: rgba(0, 0, 0, 0.8);
		width: 100%;
		color: white;
		text-align: center;
		border-radius: 5px;
	}

	.fuzzy-matching-box {
		padding-top: 20px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.query-button {
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;
		}

		.title-top {
			padding: 20px 20px;
		}

		.fuzzy-matching-top {
			height: 130px;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				:deep() {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}
			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 300px;
					padding: 16px 24px;
					// top: 50%;
					// transform: translate(0,-50%);
					// background-color: #1677FF;
				}

			}

			:deep() {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}
			}

		}

		.fuzzy-matching-content {
			height: 20px;
			line-height: 20px;
			margin-bottom: 10px;

			:deep() {
				.el-button {
					margin-left: 50px;
					font-size: 16px;

				}
			}
		}

		.block {
			display: flex;
			justify-content: center;
			text-align: center;
			font-size: 15px;
			margin-top: 10px;

			.sorter {
				margin-left: 50px;
			}

			.total {
				padding-top: 5px;
				margin-left: 800px;

			}

			.texttiao {
				color: #459FFC;

			}
		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;

			.textButton {
				// background-color: pink;
				font-size: 14px;
				font-weight: 700;
			}

			.red_bottom {
				color: red;
			}

			.green_bottom {
				color: #1BC896;
			}

			.tubiao {
				width: 12px;
			}

			.shanchuBtn {
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					height: 40px;
					line-height: 40px;
					border: 0;
					font-size: 16px;
					color: black;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					// border: 0;
				}

				.el-button--small {
					margin: 0;
					padding: 0;
				}
			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}
		}

		.upload-box {
			margin-top: 15px;
			// line-height: 25px;

			:deep() {
				.el-select .el-input {
					height: 25px;
					margin-top: 0;
				}

				.el-form-item {
					margin-bottom: 0px !important;


				}

				.el-form-item__label {
					margin-left: 50px !important;

				}

			}

			.upload-lef {
				margin-left: 50px;
				font-size: 14px;

				.upload-title {}
			}

			.el-table tr {
				font-size: 20px;
			}

			:deep() {
				.el-button--small {
					height: 30px;
					margin-left: 100px;
					padding: 0px 25px;
				}

				.el-table--enable-row-transition .el-table__body td.el-table__cell {
					font-size: 40px;
				}

				// .el-form-item--small .el-form-item__content {
				//     height: 40px;
				//     line-height: 40px;
				// }
				.el-select .el-input__inner {
					height: 35px;
				}

				.el-form-item--small .el-form-item__label {
					margin-left: 20px;
					line-height: 28px;
				}

				.el-upload-list {
					// dis
					font-size: 80px;
				}

				.el-select--small .el-select__wrapper {
					width: 200px !important;
					// height: 35px !important;
				}
			}
		}
	}
</style>